module.exports = __webpack_public_path__ + "img/members-wallpaper.eb394a60.png";